var cilResizeHeight = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M256.236,504,120,367.764V329.608h72v-144H120V146.98L255.766,11.216,392,147.452v38.156H320v144h72v38.627ZM159.1,361.608l97.137,97.137,97.137-97.137H288v-208h64.9L255.766,56.471l-97.138,97.137H224v208Z' class='ci-primary'/>"];

export { cilResizeHeight };

